import CatMouseExplainer from './CatMouseExplainer';
import ChickenRabbitExplainer from './ChickenRabbitExplainer';

/**
 * 图解模板注册表:puzzle.params.explainer.template → 组件
 *
 * 每个模板组件接收 { ...args, onDone },args 就是题目里的数字。
 * 新增题型(植树、相遇……)在这里登记一行。
 */
export const EXPLAINERS = {
  'chicken-rabbit': ChickenRabbitExplainer,
  'cat-mouse': CatMouseExplainer,
};

export function getExplainer(template) {
  return EXPLAINERS[template] || null;
}
